/**
 * 实时解盘状态
 */
const RealTimeSolutionStatus = {
    checked: true, // 已选中
    notCheck: false, // 未选中
    nothing: null // 没有实时解盘
};
Object.freeze(RealTimeSolutionStatus);

export { RealTimeSolutionStatus };

/**
 * 收藏夹状态
 */
const FavoriteStatus = {
    added: true, // 已收藏
    notAdded: false, // 未收藏
    notLogin: null // 未登录
};
Object.freeze(FavoriteStatus);

export { FavoriteStatus };



// WEBPACK FOOTER //
// ./src/controller/common/enum.js